import React, { useEffect, useState } from "react";
import { vendorServices } from "../../services/vendorServices";
import { useNavigate } from "react-router-dom";
import { onboardingServices } from "../../services/onboardingServices";
import OnboardingForm from "./onboardingFrom";
function VendorOnboardingForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [isThank, setIsThank] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [currentFormStep, setCurrentFormStep] = useState(1);
  const [vendorDetails, setVendorDetails] = useState({});
  const [formStepDetails, setFormStepDetails] = useState({});
  const [formStepFieldsDetails, setFormStepFieldsDetails] = useState({
    sections: [{ fields: [] }, { fields: [] }, { fields: [] }],
  });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  let navigate = useNavigate();

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getVendorDetails();
  }, []);

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const getVendorDetails = (url) => {
    setIsLoading(true);
    vendorServices
      .getVendorDetails()
      .then(function (response) {
        if (response?.data?.success == true) {
          setVendorDetails(response?.data?.data);
          let currentStep = 0;
          if (response?.data?.data?.vendor?.currentStep > 3) {
            currentStep = 1;
            setIsDisable(true);
          } else {
            currentStep = response?.data?.data?.vendor?.currentStep;
          }
          // setCurrentFormStep(currentStep);
          getFormStepWise(currentStep);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getFormStepWise = (currentStep) => {
    setIsLoading(true);
    onboardingServices
      .getFormStepWise("")
      .then(function (response) {
        if (response?.data?.success == true) {
          setFormStepDetails(response?.data?.data);
          getFormStepById(
            response?.data?.data?.form?.steps[Number(currentStep) - 1]?._id,
            currentStep
          );
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getFormStepById = (id, currentStep) => {
    setIsLoading(true);
    let param = `?stepId=${id}`;
    onboardingServices
      .getFormStepWise(param)
      .then(function (response) {
        if (response?.data?.success == true) {
          setFormStepFieldsDetails(response?.data?.data?.form);
          setCurrentFormStep(currentStep);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onColumnClk = (ele, idx) => {
    getFormStepById(ele?._id, idx + 1);
  };

  const onEditClk = () => {
    setIsDisable(false);
  };

  const submitForm = (bodyData) => {
    setIsLoading(true);
    onboardingServices
      .updateObForm(bodyData)
      .then(function (response) {
        if (response?.data?.success == true) {
          // setFormStepFieldsDetails(response?.data?.data?.form);
          if (currentFormStep == 3) {
            // navigate()

            onboardingServices
              .submitObForm({})
              .then(function (submitObFormRes) {

                setIsThank(true);
              })
          } else if (currentFormStep < 3) {
            getFormStepWise(currentFormStep + 1);
            setCurrentFormStep(currentFormStep + 1);
            // window.location.reload();
          }
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const openChat = () => {
    setChatOpen(!chatOpen);
  };

  return (
    <div class="login-forms">
      <div class="text-centers">
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h1>Onboarding Wizard</h1>
              </div>
            </div>
          </div>
          {/* {isDisable && (
            <div>
              <div className="ob-adit-div">
                <p onClick={onEditClk}>Edit</p>
              </div>
            </div>
          )} */}
        </section>

        <OnboardingForm />

      </div>
    </div>
  );
}

export default VendorOnboardingForm;
